				module.controller(
    'productListCtrl',
    [ '$scope', '$rootScope', '$state', 'productService','productCategoryService', 'alertService', 
        function($scope, $rootScope, $state, productService, productCategoryService,alertService) {

            $scope.filter = {
            		
            };
            
            $scope.productCategories = [];
            $scope.products = [];
            $scope.pagination = {
                current : 1,
                total : 0
            };

            /**
             *
             * @param page
             */
            $scope.search = function(page) {
                $scope.loading = true;

                page = page == undefined ? 1 : page;
                $scope.pagination.current = page;

                var filter = {};
                filter.offset = (page - 1) * $rootScope.pageSize;
                filter.limit = $rootScope.pageSize;

                if($scope.filter.name){
                    filter.name = $scope.filter.name;
                }

                if($scope.filter.category){
                    filter.categoryName = $scope.filter.category;
                }
                                
                productService.searchProducts(filter).then(function(response) {
                    $scope.loading = false;
                    var result = response.getData();

                    $scope.products = result.results;
                    $scope.pagination.total = result.totalRegisters;

                }, function(response) {
                    $scope.loading = false;
                });
            };

            $scope.remove= function(idProduct){
            	var prod = $scope.products.find(function(prod){ return prod.id == idProduct; })
                alertService.showSwtQuestion('Eliminar producto "'+ prod.name +'"', function() {
                    $scope.loading = true;

                    productService.removeProduct(idProduct).then(function(response) {
                        $scope.loading = false;
                        $scope.search(1);
                        alertService.showSuccess('Producto eliminado satisfactoriamente');
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            }
            
            /**
             *
             */
            $scope.clearFilters = function(){
                $scope.filter = {};
            };

            $scope.search(1);
            
            $scope.changeRegulationState = function(idRegulation, state){
            	if(state){
            		regulationService.enableRegulation(idRegulation).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess(REGULATION_ACTIVE);
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            	else{
            		regulationService.disableRegulation(idRegulation).then(function(response) {
            			$scope.loading = false;
            			alertService.showSuccess(REGULATION_INACTIVE);
            		}, function(response) {
            			$scope.loading = false;	
            		}); 
            	}
            };

        } ]);
